var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLargeRoundedBookmark = function SvgLargeRoundedBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 6.122V19.19c0 .568.353 1.049.882 1.224.155.043.31.087.464.087.375 0 .75-.175.992-.459L12 15.824l3.64 4.195c.353.437.926.59 1.478.394.53-.197.882-.678.882-1.224V6.122C18 4.68 16.809 3.5 15.353 3.5H8.647C7.191 3.5 6 4.68 6 6.122"
  })));
};
export default SvgLargeRoundedBookmark;